import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/rem'
import './plugins/element.js'
import 'animate.css'

Vue.config.productionTip = false

export default new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
